export const V3_VARIANTS = [
  {
    id: "redux-provenance",
    label: "Thread Redux Provenance",
    short: "Redux",
    motion: "Pull-through comb",
  },
  {
    id: "cluster-ribbon-pro",
    label: "Cluster Ribbon Pro",
    short: "Ribbon",
    motion: "Slice rail",
  },
  {
    id: "graph-explorer-canvas",
    label: "Graph Explorer Canvas",
    short: "Explorer",
    motion: "Center fan",
  },
  {
    id: "neo4j-editor-darkroom",
    label: "Neo4j Editor Darkroom",
    short: "Neo4j",
    motion: "Typed arcs",
  },
  {
    id: "drug-discovery-matrix",
    label: "Drug Discovery Matrix",
    short: "Matrix",
    motion: "Pathway bands",
  },
  {
    id: "instinct-orbital",
    label: "Instinct Orbital",
    short: "Orbital",
    motion: "Orbit snap",
  },
  {
    id: "loom-weave-projection",
    label: "Loom / Weave Projection",
    short: "Loom",
    motion: "Combed weave",
  },
  {
    id: "xray-table",
    label: "X-Ray Table",
    short: "X-Ray",
    motion: "Underlay trace",
  },
  {
    id: "correlogram-constellation",
    label: "Correlogram Constellation",
    short: "Constellation",
    motion: "Quantity stars",
  },
  {
    id: "asset-gravity-well",
    label: "Asset Gravity Well",
    short: "Gravity",
    motion: "Artifact pull",
  },
  {
    id: "presentation-command-deck",
    label: "Presentation Command Deck",
    short: "Command",
    motion: "Demo reveal",
  },
  {
    id: "v4-xray-ribbon",
    label: "V4 X-Ray Ribbon",
    short: "V4 X-Ray",
    motion: "Ribbon x-ray",
  },
  {
    id: "v4-loom-ribbon",
    label: "V4 Loom Ribbon",
    short: "V4 Loom",
    motion: "Strand comb",
  },
  {
    id: "v4-matrix-bridge",
    label: "V4 Matrix Bridge",
    short: "V4 Bridge",
    motion: "Bridge bands",
  },
] as const;

export type V3VariantId = typeof V3_VARIANTS[number]["id"];
export type V3Variant = typeof V3_VARIANTS[number];

export const DEFAULT_V3_VARIANT: V3VariantId = "redux-provenance";

export function parseV3VariantId(value: string | null | undefined): V3VariantId {
  const match = V3_VARIANTS.find((variant) => variant.id === value);
  return match?.id ?? DEFAULT_V3_VARIANT;
}

export function v3VariantById(id: V3VariantId): V3Variant {
  return V3_VARIANTS.find((variant) => variant.id === id) ?? V3_VARIANTS[0];
}
